import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"

export default styled(Flex)`
  :not(:last-child) {
    border-bottom: solid 1px ${({theme}) => theme.colors.greys.light};
    padding-bottom: 13px;
  }

  :not(:first-child) {
    padding-top: 11px;
  }
`
